// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var JsxRuntime = require("react/jsx-runtime");
var Image$ReactHooksTemplate = require("../../common/image.res.js");

function LeftPane(props) {
  var profile = props.profile;
  return JsxRuntime.jsxs("aside", {
              children: [
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("img", {
                              className: "h-8 mr-2",
                              src: Image$ReactHooksTemplate.profile
                            }),
                        "Profile Info"
                      ],
                      className: "p-4 border-b font-semibold text-lg flex items-center"
                    }),
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("div", {
                              children: JsxRuntime.jsx("img", {
                                    className: "h-10 mr-2",
                                    src: Image$ReactHooksTemplate.avatar
                                  }),
                              className: "flex justify-center items-center"
                            }),
                        JsxRuntime.jsx("h2", {
                              children: profile.name,
                              className: "text-center font-semibold text-lg"
                            }),
                        JsxRuntime.jsx("p", {
                              children: profile.location,
                              className: "text-center text-gray-500"
                            }),
                        JsxRuntime.jsx("div", {
                              children: "Health Score: " + profile.healthScore,
                              className: "bg-green-100 text-green-700 text-center text-sm py-1 rounded"
                            }),
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsxs("p", {
                                      children: [
                                        JsxRuntime.jsx("strong", {
                                              children: "Email: "
                                            }),
                                        profile.email
                                      ]
                                    }),
                                JsxRuntime.jsxs("p", {
                                      children: [
                                        JsxRuntime.jsx("strong", {
                                              children: "Phone: "
                                            }),
                                        profile.phone
                                      ]
                                    })
                              ],
                              className: "space-y-1"
                            }),
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsx("h3", {
                                      children: "Tags:",
                                      className: "font-semibold"
                                    }),
                                JsxRuntime.jsx("h3", {
                                      children: "Customer Since",
                                      className: "font-semibold mt-2"
                                    }),
                                JsxRuntime.jsx("p", {
                                      children: profile.customerSince
                                    }),
                                JsxRuntime.jsx("h3", {
                                      children: "Birthday",
                                      className: "font-semibold mt-2"
                                    }),
                                JsxRuntime.jsx("p", {
                                      children: profile.birthday
                                    }),
                                JsxRuntime.jsx("h3", {
                                      children: "Address",
                                      className: "font-semibold mt-2"
                                    }),
                                JsxRuntime.jsx("p", {
                                      children: profile.address
                                    })
                              ],
                              className: "mt-4"
                            })
                      ],
                      className: "overflow-y-auto p-4 flex-1 text-sm space-y-4"
                    })
              ],
              className: "w-1/4 bg-white border-r border-gray-200 flex flex-col"
            });
}

var make = LeftPane;

exports.make = make;
/* react/jsx-runtime Not a pure module */
